import $ from 'jquery'
import _ from 'underscore'
import messageResource from '../../messageResource'
import {arrayToSet, convertUsersFilterDependingOnFeatures, defer, makeHandler} from '../../atUtils'
import {calculateTooltipOffset} from '../../atBrowserUtils'
import GroupType from '../../enums/GroupType'
import BalanceType from '../../enums/BalanceType'
import PagerController from '../../pager/PagerController'
import UserTableController, {PUNCTUATORS as UserTablePunctuators} from './userList/table/userTable/UserTableController'
import ManagementFilter from './userList/ManagementFilter'
import SpinnerController from '../../SpinnerController'
import {TabKeys as USER_PANEL_TAB_KEYS} from '../../panels/user/constants'
import userStore from '../../store/userStore'
import User from '../../store/User'
import StringTokenizer from '../../util/StringTokenizer'
import makeRpcCall from '../../util/jquery_rpc'
import FeatureDiffStateController from '../../FeaturesDiffStateController'
import UserListConfirmation from './UserListConfirmation'
import UserNameFormat from '../../util/UserNameFormat'
import {DEFAULT_TIME_ZONE_GROUP_ID, UserManagementConstants, USERS_WITHOUT_GROUP_ID,} from '../../constants'
import PermissionsDescriptionLightBox from "./PermissionsDescriptionLightBox"
import ATUserGroupRenderer from "../../groupManagement/ATUserGroupRenderer"
import LeaveBalanceEditor from './LeaveBalanceEditor'
import {ATUserGroupManagementController} from '../../groupManagement/base_group_management_controller'
import ATAddUserGroupController from "../../groupManagement/ATAddUserGroupController"
import ATInviteSeveralUsersLightBox from './ATInviteSeveralUsersLightBox'
import {openEditUserPanel} from "../../panels/user/editPanel/actions"
import {closeCreateUserPanel, openCreateUserPanel} from "../../panels/user/createPanel/actions"
import CreateUserPanel from "../../panels/user/createPanel/CreateUserPanel"
import EditUserPanel from "../../panels/user/editPanel/EditUserPanel"
import WorkAssignmentsEditorPanel from "./workAssignmentsEditor/components/WorkAssignmentsEditorPanel"
import ManagementAssignmentsEditorPanel from "./managementAssignmentsEditor/components/ManagementAssignmentsEditorPanel"
import CustomCheckbox from "../../components/customCheckbox/CustomCheckbox"
import ManagementButtonsContainer from './components/managementButtons/ManagementButtonsContainer'
import WorkAssignmentsTabContainer from './workAssignmentsTab/WorkAssignmentsTabContainer'
import TabsContainer from "./components/tabs/TabsContainer"

import View from '../../View'
import {connect} from '../../redux/utils'
import {getActiveTabNum, getEditingUserId, getPermissionsTemplates, getSortedUsersList, isAllowedToManageAccountSettings} from './common/selectors'
import {addNewUsersToList, removeUserFromList, setUserManagementData} from './common/actions'
import {bindActionCreators} from 'redux'
import TableControls from "./components/TableControls"
import WordsFilter from "./components/WordsFilter"
import {createWarningMsgs, getUserSelectionDescription} from "./utils"
import {addDefaultUserGroup, transformListToGroups} from "../../util/groupUtils"
import {openTeamAssignmentsPanelFromUserList, setStateOnInviteSeveralUsersSuccess, setStateOnPageDataReceivedAction} from "./userList/actions"
import WorkAssignmentPanel from "./workAssignmentPanel/WorkAssignmentPanel"
import LicenseContainer from "./components/license/LicenseContainer"
import {
    setEventPreventHidingEditUserSlidingPanel,
    setEventPreventHidingManagementAssignmentsSlidingPanel,
    setEventPreventHidingTeamAssignmentSlidingPanel
} from "../../panels/utils"
import EditManagementAssignmentsPanel from "./editManagementAssignmentsPanel/components/ManagementAssignmentsPanel"
import LeaveBalanceEditorContent from './LeaveBalanceEditorContent'
import BalanceHistoryPanelContent from '../../BalanceHistoryPanelContent'
import UsersFilter from './components/UsersFilter'
import {HierarchyLevels} from 'constants'
import {openManagementAssignmentPanel} from './editManagementAssignmentsPanel/actions'
import GroupController from '../../groupManagement/group_controller'
import {isBTYEnabled, isTTAEnabled, isTZGEnabled, isUGREnabled, isURAEnabled} from '../../features/selectors'
import {updateDepartments, updateTimeZoneGroups, updateUsersGroups, updateUsersTimeZoneGroups} from './groupManagement/actions'
import {AdditionalDataConstants} from './constants'
import EditTeamAssignmentsPanel from '../../panels/user/editTeamAssignmentsPanel/EditTeamAssignmentsPanel'
import {getGenerateMoneyReportsRightTitle} from '../../permissions/PermissionsUtils'
import {isLoading} from './workAssignmentsTab/selectors'

const ErrorMap = {
    [UserManagementConstants.ERROR_NO_RIGHTS_TO_MANAGE_ACCOUNT_SETTINGS]: "userlist.js.error_manage_account_settings_right_revoked",
    [UserManagementConstants.ERROR_DUPLICATE_USERNAME]: true, //Why we use this
    [UserManagementConstants.ERROR_NO_RIGHTS_TO_MANAGE_PTO_AND_SICK]: "userlist.js.error_no_rights_to_manage_leave_balance",
    [UserManagementConstants.ERROR_PTO_FEATURE_DISABLED]: "userlist.js.error_pto_feature_disabled",
    [UserManagementConstants.ERROR_PTO_CONTROL_DISABLED]: "userlist.js.error_pto_control_disabled",
    [UserManagementConstants.ERROR_SICK_CONTROL_DISABLED]: "userlist.js.error_sick_control_disabled",
    [UserManagementConstants.ERROR_NO_SUCH_USER]: "userlist.js.error_no_such_user",
    [UserManagementConstants.ERROR_CANT_DELETE]: "userlist.js.error_cant_delete",
    [UserManagementConstants.ERROR_CANNOT_DISABLE_LAST_USER_MANAGER_IN_OTHER_PRODUCT]: "user.edit.js.cannot_disable.last_admin_at"
}

const BOTTOM_BAR_HEIGHT = 29

class UserManagementMediator extends View {
    constructor({
        openEditUserPanel,
        openCreateUserPanel,
        closeCreateUserPanel,
        setStateOnPageDataReceivedAction,
        setStateOnInviteSeveralUsersSuccess,
        openTeamAssignmentsPanel,
        openManagementAssignmentsPanel,
        addNewUsersToList,
        removeUserFromList,
        updateUserManagementData,
        updateUsersGroups,
        updateUsersTimeZoneGroups,
        updateDepartments,
        updateTimeZoneGroups,
    }) {
        super()

        $(document).on("editUserPanel_updateUserData", (e, data) => {
            if(this.state.activeTabNum !== UserManagementConstants.WORK_ASSIGNMENTS_TAB_NUM){
                this.updateCallSucceeded(data, null, false, null, data.userInfo.id, null, null, true)
            }
        })

        $(document).on("editUserPanel_deleteUserSucceeded", (e, data) => {
            if(this.state.activeTabNum !== UserManagementConstants.WORK_ASSIGNMENTS_TAB_NUM) {
                this.deleteCallSucceeded(data, data.id, null, null, null)
            }
        })

        $(document).on("editUserPanel_noSuchUserException", (e, userId) => {
            if(this.state.activeTabNum !== UserManagementConstants.WORK_ASSIGNMENTS_TAB_NUM) {
                this._deleteUser(userId)
            }
        })

        $(document).on("createUserPanel_userCreated", (e, data) => {
            this.createSingleUserCallSucceeded(data, this.createUserPanel, false, null, data.userInfo.id);
        })

        $(document).on("createUserPanel_panelClosed", () => {
            this.showGettingStartedMenuIfNeeded()
        })

        this.state = {
            activeTabNum: -1,
            allowedToManageAccountSettings: false,
            editingUserId: null,
            isURAEnabled: false,
            isBTYEnabled: false,
            isUGREnabled: false,
            isTZGEnabled: false,
            isTTAEnabled: false,
            availableUsers: [],
            permissionsTemplates: [],
            isWaTabLoading: false,
        }

        this.actions = {
            openEditUserPanel,
            openCreateUserPanel,
            closeCreateUserPanel,
            setStateOnPageDataReceivedAction,
            setStateOnInviteSeveralUsersSuccess,
            openTeamAssignmentsPanel,
            openManagementAssignmentsPanel,
            addNewUsersToList,
            removeUserFromList,
            updateUsersGroups,
            updateDepartments,
            updateUserManagementData,
            updateUsersTimeZoneGroups,
            updateTimeZoneGroups,
        }

        this.spinner = this.createSpinner();
        this.spinnerEl = "spinnerPlaceholderId";

        this.onStatePropertyChanged('activeTabNum', () => {
            this._toggleTableClassForTabs(this.state.activeTabNum)
        })

        this.onStatePropertyChanged('allowedToManageAccountSettings', () => {
            const managementButtonsPlaceholder = $('.userList_managementButtonsPlaceholder')
            if (this.state.allowedToManageAccountSettings) {
                managementButtonsPlaceholder.show()
            } else {
                managementButtonsPlaceholder.hide()
            }
        })

        this.onStatePropertyChanged('editingUserId', (userId, prevUserId) => {
            if(this.state.activeTabNum !== UserManagementConstants.WORK_ASSIGNMENTS_TAB_NUM) {
                if(userId !== null) {
                    this.userTableController.addRowSelectionByUserId(userId)
                }

                if (prevUserId !== null) {
                    this.userTableController.clearRowSelectionByUserId(prevUserId)
                }
            }
        })

        this.onStatePropertyChanged('availableUsers', (availableUsers) => {
            this.usersFilter.setState({
                users: availableUsers.map((user) => {
                    return new User(
                        user["id"],
                        user["firstName"],
                        user["lastName"],
                        user["middleInitial"],
                        user["username"],
                        user["activeInAT"] || user["enabled"],
                        false,
                        user["userGroupId"],
                        user["timeZoneGroupId"]
                    )
                })
            })
        })

        this.onStatePropertyDeeplyChanged('permissionsTemplates', templates => {
            if (this.inviteSeveralUsersPopup) this.inviteSeveralUsersPopup.updatePermissionsTemplatesData(templates)
        })

        this.onStatePropertyChanged('isWaTabLoading', loading => {
            if (loading) {
                this.spinner.spin(this.spinnerEl)
            } else {
                this.spinner.stop()
            }
        })

        this.onAnyStatePropertyChanged(['isURAEnabled', 'isBTYEnabled', 'isTTAEnabled'], () => {
            this.userTableController.setState({
                isURAEnabled: this.state.isURAEnabled,
                isBTYEnabled: this.state.isBTYEnabled,
                isTTAEnabled: this.state.isTTAEnabled
            })
        })
    }

    init(userListBeans, pagerData, userGroupList, timeZoneGroupList, viewerSettings, userListSettings,
        license, loggedInUserId, ptoHoursPerDay, usersWithoutApprovers,
        ptoDefaults, sickDefaults, exportBalanceHistoryUrl, loggedInUserGroup, loggedInUserTZGroupId) {

        this.actions.setStateOnPageDataReceivedAction({
            licenseCounters: license,
            viewerSettings: viewerSettings,
            usersWithoutApprovers: usersWithoutApprovers,
            allUserGroups: userGroupList,
            allTimeZoneGroups: timeZoneGroupList,
            records: userListBeans,
        })

        View.prototype.init.call(this)

        this.$pageEl = $('.userListPage')

        this.$userListTableContainer = $("#userListTableContainer")
        this.$workAssignmentsTablePlaceholder = $('.userList_workAssignmentsTableContainer')

        this._initTabs();

        this.loggedInUserId = loggedInUserId;
        this.loggedInUserGroup = loggedInUserGroup;

        this.time = null;
        this.rpcRequest = null;
        this.spinnerTimer = null;
        this.ptoHoursPerDay = ptoHoursPerDay;

        userListSettings.filter = convertUsersFilterDependingOnFeatures(
            userListSettings.filter,
            this.state.isUGREnabled,
            this.state.isTZGEnabled,
            this.state.availableUsers
        )

        this.currentState = {};
        this.currentState.userListSettings = userListSettings;
        this.currentState.viewerSettings = viewerSettings;
        this.currentState.recordsPerPage = pagerData.recordsPerPage;
        this.currentState.pageNum = pagerData.pageNum;
        this.currentState.totalRecords = pagerData.totalRecords;
        this.currentState.userListOrder = userListSettings.order;
        this.currentState.searchText = "";
        this.currentState.license = license;
        this.currentState.noUsersShown = userListBeans.length <= 0;

        this.newState = $.extend(true, {}, this.currentState);

        // time zone group of logged in user
        const previousLoggedInUserTZGroup = _.find(
            timeZoneGroupList,
            (tzGroup) => {
                return tzGroup.id === loggedInUserTZGroupId;
            }
        )

        // init management buttons on top
        new ManagementButtonsContainer({
            onManageUserDepartmentsClick: () => {
                this.showManageDepartmentsPopup((controller) => {
                        this._departmentsChanged(controller)
                    }
                );
            },
            onManageTimeZoneGroupsClick: () => {
                this.showManageTimeZoneGroupsPopup((controller) => {
                        // get actual time zone group off logged in user
                        const newLoggedInUserTZGroup = _.find(
                            controller.storedData,
                            (tzGroupWithUsers) => {
                                const tzGroupUserIds = _.map(tzGroupWithUsers.users, (user) => {
                                    return user.id;
                                });
                                return _.contains(tzGroupUserIds, loggedInUserId);
                            }
                        );
                        // check new and prev tz group of logged in user
                        if (previousLoggedInUserTZGroup.id !== newLoggedInUserTZGroup.id ||
                            previousLoggedInUserTZGroup.timeZoneId !== newLoggedInUserTZGroup.timeZoneId ||
                            previousLoggedInUserTZGroup.cityName !== newLoggedInUserTZGroup.cityName) {
                            // update user list if his time zone group will be changed
                            alert(messageResource.getMessage('userlist.js.time_zone_was_changed'));
                            this._reloadPage();
                            return;
                        }

                        this._timeZoneGroupsChanged(controller);
                    }
                )
            },
            onAddNewUserClick: () => this.createUser(),
            onManualInvitationsClick: () => this.inviteSeveralUsers(),
            onImportUsersFinished: (importedUsersData) => this.importUsersFinished(importedUsersData)
        }).init($('.userList_managementButtonsPlaceholder'))

        new LicenseContainer().init($('.licenseInfoPlaceholder'))

        // init workAssignments tab
        this.workAssignmentsTableContainer = new WorkAssignmentsTabContainer().init(this.$workAssignmentsTablePlaceholder)

        this.userGroupMap = this._initGroupMap(userGroupList, true, USERS_WITHOUT_GROUP_ID)
        this.userGroupList = userGroupList

        this.timeZoneGroupMap = this._initGroupMap(timeZoneGroupList, false, DEFAULT_TIME_ZONE_GROUP_ID)
        this.timeZoneGroupList = timeZoneGroupList

        this._initFilters();

        this.usersFilter = new UsersFilter({
            onChange: ({userIds, groupIds, groupType, allSelected}) => {
                this._filterByUsersChangedCallBack(this.currentState.userListSettings.filter.showDisabled, userIds, groupIds, groupType, allSelected)
            },
            createSelectionDescription: getUserSelectionDescription,
        })

        this.wordsFilterComponent = new WordsFilter({
            onChange: (text) => this._searchTermsChangedCallback(text)
        })

        this.tableControls = new TableControls({
            wordsFilterComponent: this.wordsFilterComponent,
            usersFilterComponent: this.usersFilter,
            onUserSortClick: (e) => this._sortingChangedCallback(e, UserManagementConstants.USER_LIST_ORDER_BY_NAME),
            onUserGroupSortClick: (e) => this._sortingChangedCallback(e, UserManagementConstants.USER_LIST_ORDER_BY_GROUP_NAME),
            onTimeZoneSortClick: (e) => this._sortingChangedCallback(e, UserManagementConstants.USER_LIST_ORDER_BY_TIME_ZONE_GROUP_NAME),
        }).init($('.userNameSelectorsTable'))
        this.tableControls.setState({
            sorting: userListSettings.order,
            showUserGroups: this._isUGREnabled(),
            showTimeZoneGroups: this._isTZGEnabled(),
        })

        this.pagerController = this._initPagerController(
            pagerData,
            (pageNum) => { this._pageNumChangedCallback(pageNum); },
            (recordsPerPage) => { this._recordsPerPageChangedCallback(recordsPerPage); }
        );

        this.userTableController = this._initUserTableController(
            userListSettings, viewerSettings, userListBeans, this.userGroupMap, this.timeZoneGroupMap, usersWithoutApprovers, ptoDefaults, sickDefaults);

        this.userTableController.init();

        this.usersFilter.setState({
            userGroups: userGroupList !== null ? transformListToGroups(addDefaultUserGroup(userGroupList)) : null,
            timeZoneGroups: transformListToGroups(this.timeZoneGroupList),
            groupType: this.currentState.userListSettings.filter.groupType,
            userIds: this.currentState.userListSettings.filter.userIds || [],
            groupIds: this.currentState.userListSettings.filter.groupIds || [],
            allSelected: this.currentState.userListSettings.filter.allSelected,
        })

        this.toggleNoUsersCaption(userListBeans.length, this.currentState.userListSettings.filter.groupIds || this.currentState.userListSettings.filter.userIds)

        this.pageBodyEl = document.getElementById("pageBody");

        this.initHeaderSelectorsFunction = () => {
            this.showDisabledUsersChBox.setState({
                checked: this.currentState.userListSettings.filter.showDisabled
            })
            new PermissionsDescriptionLightBox().init($("#permissionsInfoIcon"));
        };

        this._updateUIAccordingToViewerPermissions();

        this.leaveBalanceEditor = new LeaveBalanceEditorContent().init(this.$pageEl)

        this._balanceHistoryPanel = new BalanceHistoryPanelContent({
            exportBalanceHistoryUrl
        }).init(this.$pageEl)

        this.$tableContainerEl = $("#balanceHistoryTableBodyDiv");

        new EditUserPanel().init(this.$pageEl)

        new EditTeamAssignmentsPanel().init(this.$pageEl)

        new CreateUserPanel().init(this.$pageEl)

        new WorkAssignmentPanel().init(this.$pageEl);

        new WorkAssignmentsEditorPanel().init(this.$pageEl)

        new EditManagementAssignmentsPanel().init(this.$pageEl)

        new ManagementAssignmentsEditorPanel().init(this.$pageEl)

        _.each(userListBeans, (user) => {
            userStore.add(new User(
                user["id"],
                user["firstName"],
                user["lastName"],
                user["middleInitial"],
                user["username"],
                user["enabled"],
                false,
                user["userGroupId"],
                user["timeZoneGroupId"]
            ));
        });

        return this;
    }

    showGettingStartedMenuIfNeeded() {
        // on hide show getting started menu if need
        if (!_.isUndefined(window.GettingStartedShortcuts)) {
            window.GettingStartedShortcuts.showJustCheckedShortcutIfExists();
        }
    }

    _initPagerController(pagerData, pageNumChangedCallback, recordsPerPageChangedCallback) {
        return new PagerController().init(
            {
                pagerData: pagerData,
                handlersMap: {
                    pageChanged: pageNumChangedCallback,
                    recordsPerPageChanged: recordsPerPageChangedCallback
                },
                pagerControlsElementId: "userListFooterId",
                pagerElementId: "pager",
                recordsPerPageSelectorId: "recordsPerPageSelector",
                minRecordsPerPage: UserManagementConstants.MIN_RECORDS_PER_PAGE
            }
        )
    }

    _initUserTableController(userListSettings, viewerSettings, userListBeans, groupMap, timeZoneGroupMap, usersWithoutApprovers, ptoDefaults, sickDefaults) {
        const tHeadEl = document.getElementById("userListTableHeader"),
            handlersMap = {};

        handlersMap.sortByPTO = (event) => { this._sortingChangedCallback(event, UserManagementConstants.USER_LIST_ORDER_BY_PTO_BALANCE); };
        handlersMap.sortByApprovedPTO = (event) => { this._sortingChangedCallback(event, UserManagementConstants.USER_LIST_ORDER_BY_APPROVED_PTO); };
        handlersMap.sortByPTOControl = (event) => { this._sortingChangedCallback(event, UserManagementConstants.USER_LIST_ORDER_BY_PTO_CONTROL_STATUS); };

        handlersMap.sortBySick = (event) => { this._sortingChangedCallback(event, UserManagementConstants.USER_LIST_ORDER_BY_SICK_BALANCE); };
        handlersMap.sortByApprovedSick = (event) => { this._sortingChangedCallback(event, UserManagementConstants.USER_LIST_ORDER_BY_APPROVED_SICK); };
        handlersMap.sortBySickControl = (event) => { this._sortingChangedCallback(event, UserManagementConstants.USER_LIST_ORDER_BY_SICK_CONTROL_STATUS); };

        handlersMap.editUserAccountSettings = (cell, e) =>{
            setEventPreventHidingEditUserSlidingPanel(e)
            defer(() => {
                this.editUser(cell, USER_PANEL_TAB_KEYS.ACCOUNT_SETTINGS)

            })
        };

        handlersMap.editUserPermissions = (cell, e) => {
            setEventPreventHidingEditUserSlidingPanel(e)
            defer(() => {
                this.editUser(cell, USER_PANEL_TAB_KEYS.PERMISSIONS)
            })
        }

        handlersMap.editTeamAssignmentsPermissions = (cell, e) => {
            setEventPreventHidingTeamAssignmentSlidingPanel(e)
            defer(() => {
                this.editTeamAssignments(cell)
            })
        }

        handlersMap.editManagementAssignmentsPermissions = (cell, e) => {
            setEventPreventHidingManagementAssignmentsSlidingPanel(e)
            defer(() => {
                this.editManagementAssignments(cell)
            })
        }

        handlersMap.editPTOBalance = (cell) => { this.editBalance(cell, BalanceType.PTO) };
        handlersMap.editSickDaysBalance = (cell) => { this.editBalance(cell, BalanceType.SICK) };
        handlersMap.switchManagePTOAndSickRight = (cell) => { this.switchManagePTOAndSickRight(cell)};
        handlersMap.showPtoHistory = (cell) => { this.showPtoHistory(cell) };
        handlersMap.showSickHistory = (cell) => { this.showSickHistory(cell) };
        handlersMap.togglePTOControlStatus = (cell, value) => { this.toggleBalanceControlStatus(cell, BalanceType.PTO, value) };
        handlersMap.toggleSickDaysControlStatus = (cell, value) => { this.toggleBalanceControlStatus(cell, BalanceType.SICK, value) };
        handlersMap.toggleIsTTApprover = (cell) => { this.toggleIsTTApprover(cell) };
        handlersMap.modifyPTOAccrualRules = (cell, dialogValues, onCompleteCallback) => {
            this.modifyBalanceAccrualRules(cell, BalanceType.PTO, dialogValues, onCompleteCallback)
        };
        handlersMap.modifySickAccrualRules = (cell, dialogValues, onCompleteCallback) => {
            this.modifyBalanceAccrualRules(cell, BalanceType.SICK, dialogValues, onCompleteCallback)
        };

        return new UserTableController({
                containerEl: this.$userListTableContainer,
                tHeadEl: tHeadEl,
                userBeans: userListBeans,
                canManageLeaveBalances: viewerSettings.allowedToManageLeaveBalanceSettings,
                canManageAccounts: viewerSettings.allowedToManageAccountSettings,
                canManageScope: viewerSettings.allowedToManageScope,
                accountSettingsVisible: viewerSettings.showAccountSettings,
                usersWithoutApprovers: usersWithoutApprovers,
                ptoFeatureEnabled: this._isPTOEnabled(),
                sickFeatureEnabled: this._isSickEnabled(),
                wasFeatureEnabled: this._isWASEnabled(),
                ugrFeatureEnabled: this._isUGREnabled(),
                sortOrder: userListSettings.order,
                handlersMap: handlersMap,
                ptoHoursPerDay: this.ptoHoursPerDay,
                groupMap: groupMap,
                timeZoneGroupMap: timeZoneGroupMap,
                ptoDefaults: ptoDefaults,
                sickDefaults: sickDefaults,
                generateMoneyReportsTitle: getGenerateMoneyReportsRightTitle(this._isURAEnabled(), this._isBTYEnabled()),
            }
        )
    }

    _initGroupMap(groupList, includeNullGroup) {
        let groupMap = null;
        if (groupList !== null) {
            groupMap = {};

            if (includeNullGroup) {
                groupMap[UserManagementConstants.USER_WITHOUT_GROUP] = messageResource.getMessage("userlist.js.table.username_cell.user_without_group");
            }

            for (let i = 0; i < groupList.length; i++) {
                const group = groupList[i];
                if (includeNullGroup && group.id === UserManagementConstants.USER_WITHOUT_GROUP)
                    continue;

                groupMap[group.id] = group.name;
            }
        }

        return groupMap
    }

    showManageDepartmentsPopup(departmentsChangedCallback) {
        if (!this.manageDeparmentsController) {
            this.manageDeparmentsController = new ATUserGroupManagementController();
            window.GroupManagementUtil.initializeGroupsLightBox(this.manageDeparmentsController, new ATUserGroupRenderer(), new GroupController(),
                new ATAddUserGroupController());
        }

        const popup = window.createLightbox(
            "groupManagementLightBox",
            () => {
                this.manageDeparmentsController.hideLightboxHandler(() => {
                    departmentsChangedCallback(this.manageDeparmentsController);
                })
            },
            makeHandler(this.manageDeparmentsController.isPermitToHideLightbox, this.manageDeparmentsController));

        this.manageDeparmentsController.setLightbox(popup);
        this.manageDeparmentsController.initAfterShowing();
    }

    showManageTimeZoneGroupsPopup(timeZoneGroupsChangedCallback) {
        if (!this.manageTimeZoneGroupsController) {
            this.manageTimeZoneGroupsController = window.GroupManagementUtil.initializeTimeZoneGroupsLightBox()
        }

        const popup = window.createLightbox(
            "timeZoneGroupManagementLightBox",
            () => {
                this.manageTimeZoneGroupsController.hideLightboxHandler(() => {
                    timeZoneGroupsChangedCallback(this.manageTimeZoneGroupsController)
                })
            },
            makeHandler(this.manageTimeZoneGroupsController.isPermitToHideLightbox, this.manageTimeZoneGroupsController))

        this.manageTimeZoneGroupsController.setLightbox(popup)
        this.manageTimeZoneGroupsController.initAfterShowing()
    }

    abortPreparedAndActiveRequests() {
        clearTimeout(this.timer)

        if (this.rpcRequest)
            this.rpcRequest.abort()
    }

    prepareInitialRequest(onTimer, withDelay) {

        this.abortPreparedAndActiveRequests();

        this.abortPreparedOrActiveSpin();

        if (withDelay) {
            this.timer = setTimeout(onTimer, 200);
            this.spinInAfterDelay(200);
        }
        else {
            this.spinner.spin(this.spinnerEl);
            onTimer();
        }
    }

    _abortRequestsAndRevertState() {
        this.abortPreparedAndActiveRequests()
        this.abortPreparedOrActiveSpin()
        this._revertState()
    }

    onShowDisabledUsersCallBack(showDisabled) {
        this._filterByUsersChangedCallBack(
            showDisabled,
            this.currentState.userListSettings.filter.userIds,
            this.currentState.userListSettings.filter.groupIds,
            this.currentState.userListSettings.filter.groupType,
            this.currentState.userListSettings.filter.allSelected,
        )
    }

    createSpinner() {
        return new SpinnerController();
    }

    spinInAfterDelay(delay) {
        this.spinnerTimer = setTimeout(() => {
            this.spinner.spin(this.spinnerEl)
        }, delay);
    }

    abortPreparedOrActiveSpin() {
        clearTimeout(this.spinnerTimer);
        this.spinner.stop();
    }

    hideNoUsersCaptionAndBottomSpacer() {
        if (this.noUsersCaptionisHidden)
            return;

        $(".bottomSpacer").remove();
        const noUsersCaptionEl = document.getElementById("noUsersToShowId");
        noUsersCaptionEl.style.display = 'none';
    }

    toggleNoUsersCaption(recordsSize, customUsersSelected) {
        const noUsersCaptionEl = document.getElementById("noUsersToShowId");
        if (recordsSize === 0) {
            noUsersCaptionEl.style.display = 'block';
            this.noUsersCaptionisHidden = false;
            const groupType = this.currentState.userListSettings.filter.groupType;
            const noEnabledUsersMsg = customUsersSelected ?
                                      (groupType === GroupType.USER_GROUP ?
                                       messageResource.getEscapedMessage('userlist.js.users_table_no_enabled_users_found_in_selected_user_groups') :
                                       messageResource.getMessage('userlist.js.users_table_no_enabled_users_found_in_selected_time_zone_groups')) :
                                      messageResource.getMessage('userlist.js.users_table_no_enabled_users_found');
            const noUsersMsg = customUsersSelected ?
                               (groupType === GroupType.USER_GROUP ?
                                messageResource.getEscapedMessage('userlist.js.users_table_no_users_found_in_selected_user_groups') :
                                messageResource.getMessage('userlist.js.users_table_no_users_found_in_selected_time_zone_groups')) :
                               messageResource.getMessage('userlist.js.users_table_no_users_found');
            noUsersCaptionEl.innerHTML = this.currentState.userListSettings.filter.showDisabled ? noUsersMsg : noEnabledUsersMsg;
        } else {
            noUsersCaptionEl.style.display = 'none';
            this.noUsersCaptionisHidden = true;
        }
    }

    getSortedUserList(userListBeansArrivedCallBack, withDelay) {

        this.tokens = this.newState.searchText === null ? [] : new StringTokenizer(UserTablePunctuators).getTokens(this.newState.searchText.toLowerCase());

        const params = [
            this.newState.userListSettings.filter, this.tokens,
            this.newState.userListOrder, this.newState.pageNum, this.newState.recordsPerPage
        ];
        const successHandler = (result, textStatus, jqXHR) => {
            this.abortPreparedOrActiveSpin();
            userListBeansArrivedCallBack(result);

            this.actions.setStateOnPageDataReceivedAction(result)
        };

        const failHandler = (result, textStatus, jqXHR) => {
            if (textStatus === 'abort')
                return;

            this.abortPreparedOrActiveSpin();
            this._revertState();
        };

        this.prepareInitialRequest(() => {this.rpcRequest = makeRpcCall("UserManagementService.getUsers", params, successHandler, failHandler)}, withDelay);
    }

    _revertState() {
        this._revertUI();
        this.newState = $.extend(true, {}, this.currentState);
    }

    _revertUI() {
        this.managementFilter.setState({
            selectedValue: this.currentState.userListSettings.filter.managementFilter
        })
        this.showDisabledUsersChBox.setState({
            checked: this.currentState.userListSettings.filter.showDisabled
        })
        this.wordsFilterComponent.setState({
            test: this.currentState.searchText
        })
        this.pagerController.setRecordsPerPage(this.currentState.recordsPerPage);
    }

    _updateCurrentState(userListPageData) {
        this.currentState.recordsPerPage = this.newState.recordsPerPage;
        this.currentState.userListOrder.order = this.newState.userListOrder.order;
        this.currentState.userListOrder.asc = this.newState.userListOrder.asc;
        this.currentState.searchText = this.newState.searchText;
        this.currentState.totalRecords = userListPageData.totalRecords;
        this.currentState.pageNum = userListPageData.pageNum;
        this.currentState.viewerSettings = userListPageData.viewerSettings;
        this.currentState.userListSettings.filter.showDisabled = this.newState.userListSettings.filter.showDisabled;
        this.currentState.userListSettings.filter.userIds = this.newState.userListSettings.filter.userIds
        this.currentState.userListSettings.filter.groupIds = this.newState.userListSettings.filter.groupIds
        this.currentState.userListSettings.filter.groupType = this.newState.userListSettings.filter.groupType
        this.currentState.userListSettings.filter.allSelected = this.newState.userListSettings.filter.allSelected
        this.currentState.userListSettings.filter.managementFilter = this.newState.userListSettings.filter.managementFilter
        this.currentState.noUsersShown = userListPageData.records.length <= 0;
    }

    _updateCurrentStateFromUserData(userData) {
        const oldFeatures = this.currentState.viewerSettings.enabledFeatures;
        const newFeatures = userData.userManagementData.viewerSettings.enabledFeatures;

        const featureDiff = new FeatureDiffStateController().init(oldFeatures, newFeatures);
        const areRightsChanged = this._areUserRightsChanged(this.currentState.viewerSettings, userData.userManagementData.viewerSettings);

        window.SystemSettings.dateFormat = userData.userManagementData.dateFormat;

        this.currentState.viewerSettings = userData.userManagementData.viewerSettings;

        return {featureDiff: featureDiff, areRightsChanged: areRightsChanged};
    }

    _getDiffBetweenFeaturesAndRights(data, oldFeatureDiff) {
        const currentState = this.currentState;
        const oldFeatures = currentState.viewerSettings.enabledFeatures;
        const newFeatures = data.viewerSettings.enabledFeatures;
        let newFeatureDiff = new FeatureDiffStateController().init(oldFeatures, newFeatures);
        if (oldFeatureDiff !== null) {
            if (newFeatureDiff.featuresChanged)
                newFeatureDiff = this._intersectTwoSuccessiveFeaturesChanges(oldFeatureDiff, newFeatureDiff);
            else
                newFeatureDiff = oldFeatureDiff;
        }

        return {
            // !Note, that the _getFeatureDiff() method changes the oldFeatures object.
            // If you will need it later, make its copy before calling this method.
            featureDiff: newFeatureDiff,
            userRightsChanged: this._areUserRightsChanged(currentState.viewerSettings, data.viewerSettings),
            areAllowedToManageAccountSettingsChanged: this._areAllowedToManageAccountSettingsChanged(currentState.viewerSettings, data.viewerSettings),
            areAllowedToManageLeaveBalanceSettingsChanged: this._areAllowedToManageLeaveBalanceSettingsChanged(currentState.viewerSettings, data.viewerSettings),
            showAccountSettingsChanged: this._areShowAccountSettingsChanged(currentState.viewerSettings, data.viewerSettings)
        }
    }

    _getDiffBetweenStates(data) {

        const currentState = this.currentState;
        const oldLicense = currentState.license;
        const newLicense = this.newState.license;
        const oldShowDisabledUsers = this.currentState.userListSettings.filter.showDisabled
        const newShowDisabledUsers = this.newState.userListSettings.filter.showDisabled
        const oldNoUsersShown = currentState.noUsersShown;
        const newNoUsersShown = data.records.length <= 0;

        const result = this._getDiffBetweenFeaturesAndRights(data, null);
        result.licenseChanged = this._isLicenseChanged(oldLicense, newLicense);
        result.numOfRecordsChanged = oldNoUsersShown !== newNoUsersShown || oldShowDisabledUsers !== newShowDisabledUsers;
        result.groupTypeChanged = currentState.userListSettings.filter.groupType !== this.newState.userListSettings.filter.groupType;

        return result;
    }

    _isLicenseChanged(oldLicense, newLicense) {

        return oldLicense.allowedCount !== newLicense.allowedCount ||
               oldLicense.actualCount !== newLicense.actualCount;

    }

    _areUserRightsChanged(oldViewerSettings, newViewerSettings) {
        return this._areAllowedToManageAccountSettingsChanged(oldViewerSettings, newViewerSettings) ||
               this._areAllowedToManageLeaveBalanceSettingsChanged(oldViewerSettings, newViewerSettings) ||
               this._areShowAccountSettingsChanged(oldViewerSettings, newViewerSettings);
    }

    _areAllowedToManageAccountSettingsChanged(oldViewerSettings, newViewerSettings) {
        return oldViewerSettings.allowedToManageAccountSettings !== newViewerSettings.allowedToManageAccountSettings
    }

    _areShowAccountSettingsChanged(oldViewerSettings, newViewerSettings) {
        return oldViewerSettings.showAccountSettings !== newViewerSettings.showAccountSettings
    }

    _areAllowedToManageLeaveBalanceSettingsChanged(oldViewerSettings, newViewerSettings) {
        return oldViewerSettings.allowedToManageLeaveBalanceSettings !== newViewerSettings.allowedToManageLeaveBalanceSettings
    }

    //this method intersect two successive changes features  (nedded for show popups user)
    _intersectTwoSuccessiveFeaturesChanges(oldFeaturesDiff, newFeaturesDiff) {
        for (let f in oldFeaturesDiff.addedFeatures) {
            if (newFeaturesDiff.deletedFeatures[f]) {
                delete  oldFeaturesDiff.addedFeatures[f];
                delete  newFeaturesDiff.deletedFeatures[f]
            }
        }
        for (let f in oldFeaturesDiff.deletedFeatures) {
            if (newFeaturesDiff.addedFeatures[f]) {
                delete  oldFeaturesDiff.deletedFeatures[f];
                delete  newFeaturesDiff.addedFeatures[f];
            }
        }
        for (let f in newFeaturesDiff.addedFeatures) {
            oldFeaturesDiff.addedFeatures[f] = true;
        }
        for (let f in newFeaturesDiff.deletedFeatures) {
            oldFeaturesDiff.deletedFeatures[f] = true;
        }

        oldFeaturesDiff.validateFeaturesChanged();
        return oldFeaturesDiff;
    }

    _userListPageDataReceived(userListPageData) {
        const diffBetweenStates = this._getDiffBetweenStates(userListPageData);
        this._updateCurrentState(userListPageData);

        if (!this.validateIsChangedFeaturesOrRights(diffBetweenStates, false))
            return;

        this.ptoHoursPerDay = userListPageData.ptoHoursPerDay;

        if (this._isUGREnabled() || this._isTZGEnabled()) {
            const previouslySelectedGroupIds = this._rebuildGroupMapAndUpdateFilter(userListPageData.allUserGroups, userListPageData.allTimeZoneGroups);
            if (this.currentState.userListSettings.filter.groupType === GroupType.USER_GROUP) {
                for (let groupId in previouslySelectedGroupIds.userGroups) {
                    if (!this.userGroupMap[groupId]) {
                        this._onGroupDeletedCallBack();
                        break;
                    }
                }
            }
            else if (this.currentState.userListSettings.filter.groupType === GroupType.TIME_ZONE_GROUP) {
                for (let groupId in previouslySelectedGroupIds.timeZoneGroups) {
                    if (!this.timeZoneGroupMap[groupId]) {
                        this._onGroupDeletedCallBack();
                        break;
                    }
                }
            }
        }

        this.pagerController.setPagerStateAndUpdateUI(this.currentState.totalRecords, this.currentState.pageNum, this.currentState.recordsPerPage);

        this.userTableController.setUserTableStateAndUpdateUI(
            userListPageData.records,
            this.userGroupMap,
            this.timeZoneGroupMap,
            userListPageData.usersWithoutApprovers,
            this.currentState.viewerSettings,
            this.currentState.userListOrder,
            this.tokens,
            this._isPTOEnabled(),
            this.ptoHoursPerDay,
        );

        if (diffBetweenStates.featureDiff.areFeaturesChanged() || diffBetweenStates.licenseChanged)
            this._updateUIAccordingToViewerPermissions();

        const userGroupIds = this.currentState.userListSettings.filter.groupIds;
        const userIds = this.currentState.userListSettings.filter.userIds

        if (diffBetweenStates.numOfRecordsChanged || diffBetweenStates.groupTypeChanged)
            this.toggleNoUsersCaption(userListPageData.records.length, (userGroupIds && userGroupIds.length > 0 || userIds && userIds.length > 0))

        this.showDisabledUsersChBox.setState({
            checked: this.currentState.userListSettings.filter.showDisabled
        })

        this._scrollToTableTop();
    }

    _scrollToTableTop() {
        const windowTop = $(window).scrollTop();
        const topPositionMustBeVisible = this.$userListTableContainer.offset().top - 55;

        if (windowTop > topPositionMustBeVisible) {
            window.scrollTo(0, topPositionMustBeVisible);
        }
    }

    _updateUIAccordingToViewerPermissions() {
        this.pageBodyEl.className = this._getPageBodyClasses();
    }

    _hasManageAccountSettings() {
        return this.currentState.viewerSettings.allowedToManageAccountSettings;
    }

    _getPageBodyClasses() {
        const classes = [];
        if (!this._hasManageAccountSettings()) {
            classes.push("addUserHidden");
            classes.push("editGroupsHidden");
        }

        if (!this._isUGREnabled())
            classes.push("ugrDisabled");

        if (!this._isTZGEnabled())
            classes.push("tzgDisabled");

        classes.push("usersManagement pageBody");

        return classes.join(" ");

    }

    _isUGREnabled() {
        return this.validateEnabledFeature(UserManagementConstants.UGRFeature);
    }

    _isTZGEnabled() {
        return this.validateEnabledFeature(UserManagementConstants.TZGFeature);
    }

    _onFeatureChanged(isEnablesFeature, featureTitle, needReload) {
        let msg = messageResource.getMessage("userlist.js.error_change_feature.prefix");
        msg += " ";
        msg += isEnablesFeature ? messageResource.getMessage("userlist.js.error_change_feature.enabled")
            : messageResource.getMessage("userlist.js.error_change_feature.disabled");
        msg += " ";
        msg += featureTitle;
        msg += " ";
        msg += needReload ? messageResource.getMessage("userlist.js.error_change_feature.suffix_reloaded")
            : messageResource.getMessage("userlist.js.error_change_feature.suffix_updated")

        alert(msg);

        if (needReload)
            this._reloadPage()
    }

    _onShowPTOSettingsChanged() {
        const ptoEnabled = this._isPTOEnabled();
        const sickEnabled = this._isSickEnabled();
        let haveRightMsg;
        let noRightMsg;
        if (ptoEnabled && sickEnabled) {
            haveRightMsg = "userlist.js.error_have_right_to_view_pto_and_sick_tabs";
            noRightMsg = "userlist.js.error_no_right_to_view_pto_and_sick_tabs";
        }
        else if (ptoEnabled) {
            haveRightMsg = "userlist.js.error_have_right_to_view_pto_tab";
            noRightMsg = "userlist.js.error_no_right_to_view_pto_tab";
        }
        else if (sickEnabled) {
            haveRightMsg = "userlist.js.error_have_right_to_view_sick_tab";
            noRightMsg = "userlist.js.error_no_right_to_view_sick_tab";
        }
        this._onRightChanged(this.currentState.viewerSettings.allowedToManageLeaveBalanceSettings,
            haveRightMsg,
            noRightMsg);
    }

    _onShowAccountSettingsChanged() {
        this._onRightChanged(this._isAccountSettingsVisible(),
            "userlist.js.error_have_right_to_view_account_tab",
            "userlist.js.error_no_right_to_view_account_tab");
    }


    _onManageAccountSettingsChanged() {
        this._onRightChanged(this._hasManageAccountSettings(),
            "userlist.js.error_have_right_to_manage_account",
            "userlist.js.error_no_right_to_view_account_tab_readonly");
    }

    _onRightChanged(isVisible, keyTextHaveRights, keyTextNotHaveRights) {
        const messageKey = isVisible ? keyTextHaveRights : keyTextNotHaveRights;
        alert(messageResource.getMessage(messageKey));

        if(isVisible) {
            this.getSortedUserList(
                (userListPageData) => {

                    this.actions.setStateOnPageDataReceivedAction({
                        licenseCounters: userListPageData.licenseCounters,
                        viewerSettings: userListPageData.viewerSettings,
                        usersWithoutApprovers: userListPageData.usersWithoutApprovers,
                        allUserGroups: userListPageData.allUserGroups,
                        allTimeZoneGroups: userListPageData.allTimeZoneGroups,
                        records: userListPageData.records,
                    })

                    this._updateCurrentState(userListPageData)

                    this.userTableController.setState({
                        ptoDefaults: userListPageData.ptoDefaults,
                        sickDefaults: userListPageData.sickDefaults
                    })

                    this.userTableController.setUserTableStateAndUpdateUI(
                        userListPageData.records,
                        this.userGroupMap,
                        this.timeZoneGroupMap,
                        userListPageData.usersWithoutApprovers,
                        this.currentState.viewerSettings,
                        this.currentState.userListOrder,
                        this.tokens,
                        this._isPTOEnabled(),
                        this.ptoHoursPerDay,
                    );
                }
            )
        }
    }

    _onUGRChanged() {
        this._onFeatureChanged(this._isUGREnabled(), messageResource.getMessage("userlist.js.error_change_feature.user_groups"), true);
    }

    _onTZGChanged() {
        this._onFeatureChanged(this._isTZGEnabled(), messageResource.getMessage("userlist.js.error_change_feature.time_zone_groups"), true);
    }

    _onPTOChanged() {
        this._onFeatureChanged(this._isPTOEnabled(), messageResource.getMessage("features.PTO.title"), true);
    }

    _onSickChanged () {
        this._onFeatureChanged(this._isSickEnabled(), messageResource.getMessage("features.SDB.title"), true);
    }

    _onTTAChanged() {
        this._onFeatureChanged(this._isTTAEnabled(), messageResource.getMessage("features.TTA.title"), true);
    }

    _onOVRChanged() {
        this._onFeatureChanged(this._isOVREnabled(), messageResource.getMessage("features.OVR.title"), false);
    }

    _onURAChanged() {
        this._onFeatureChanged(this._isURAEnabled(), messageResource.getMessage("features.URA.title"), false);
    }

    _onLVTChanged() {
        this._onFeatureChanged(this._isLVTEnabled(), messageResource.getMessage("features.LVT.title"), false);
    }

    _onGenerateMoneyReportsRightChanged() {
        if (this._isGenerateMoneyReportEnabled())
            alert(messageResource.getMessage("userlist.js.alert_change_features.money_reports_enabled"))
        else
            alert(messageResource.getMessage("userlist.js.alert_change_features.money_reports_disabled"))
    }

    _isPTOEnabled() {
        return this.validateEnabledFeature(UserManagementConstants.PTOFeature);
    }

    _isSickEnabled() {
        return this.validateEnabledFeature(UserManagementConstants.SDBFeature);
    }

    _isTTAEnabled() {
        return this.validateEnabledFeature(UserManagementConstants.TTAFeature);
    }

    _isWASEnabled() {
        return this.validateEnabledFeature(UserManagementConstants.WASFeature)
    }

    _isURAEnabled() {
        return this.validateEnabledFeature(UserManagementConstants.URAFeature)
    }

    _isOVREnabled() {
        return this.validateEnabledFeature(UserManagementConstants.OVRFeature)
    }

    _isLVTEnabled() {
        return this.validateEnabledFeature(UserManagementConstants.LVTFeature)
    }

    _isBTYEnabled() {
        return this.validateEnabledFeature(UserManagementConstants.BTYFeature)
    }

    _isGenerateMoneyReportEnabled() {
        return this._isURAEnabled() || this._isBTYEnabled()
    }

    _isAccountSettingsVisible() {
        return this.currentState.viewerSettings.showAccountSettings;
    }

    _isPTOSettingsVisible() {
        return this.currentState.viewerSettings.allowedToManageLeaveBalanceSettings && this._isPTOEnabled();
    }

    _isSickDaysSettingsVisible() {
        return this.currentState.viewerSettings.allowedToManageLeaveBalanceSettings && this._isSickEnabled();
    }

    validateEnabledFeature(featureName) {
        return this.currentState.viewerSettings.enabledFeatures.hasOwnProperty(featureName);
    }

    _pageNumChangedCallback(pageNum) {
        this.newState.pageNum = pageNum;

        this.getSortedUserList(
            (userListPageData) => {
                this._userListPageDataReceived(userListPageData);

                if (this._hasManageAccountSettings()) {
                    // TODO global variable?
                    window.licenseChanged = this._isLicenseChanged(this.currentState.license, userListPageData.licenseCounters);
                    this.currentState.license = userListPageData.licenseCounters;
                    this._updateUIAccordingToViewerPermissions();
                }
            }
        )

    }

    _recordsPerPageChangedCallback(recordsPerPage) {
        this.newState.recordsPerPage = recordsPerPage
        this.pagerController.loadPage(1)
    }

    _sortingChangedCallback(event, order) {
        //this.spinner.spin(this.spinnerEl);
        this.userTableController.removeTrSpacers();

        this.newState.userListOrder.asc = order !== this.currentState.userListOrder.order || !this.currentState.userListOrder.asc;
        this.newState.userListOrder.order = order;
        this.newState.pageNum = 1;

        this.tableControls.setState({
            sorting: this.newState.userListOrder,
        })

        this.pagerController.loadPage(1);
        //this.spinner.stop();
    }

    _searchTermsChangedCallback(inputText) {
        this.userTableController.removeTrSpacers();
        this._searchTerms(inputText);
    }

    _searchTerms(text) {
        this.newState.searchText = text;
        if (this.currentState.searchText !== this.newState.searchText) {
            const pagerController = this.pagerController;

            // set timer to make request later to prevent from too fast keyboard typing
            this.prepareInitialRequest(() => pagerController.loadPage(1), true)
        }
    }

    _filterByUsersChangedCallBack(showDisabled, userIds, groupIds, groupType, allSelected) {
        this.newState.userListSettings.filter.showDisabled = showDisabled
        this.newState.userListSettings.filter.userIds = userIds
        this.newState.userListSettings.filter.groupIds = groupIds
        this.newState.userListSettings.filter.groupType = groupType
        this.newState.userListSettings.filter.allSelected = allSelected
        this.pagerController.loadPage(1)
    }

    _filterChange(nameFilter, value) {
        //this.spinner.spin(this.spinnerEl);
        this.newState.userListSettings.filter[nameFilter] = value;
        this.pagerController.loadPage(1);
        //this.spinner.stop();
    }

    _onGroupDeletedCallBack() {
        this.usersFilter.setState({
            groupType: this.currentState.userListSettings.filter.groupType,
            groupIds: [],
        })
        this._filterByUsersChangedCallBack(
            this.currentState.userListSettings.filter.showDisabled,
            this.currentState.userListSettings.filter.userIds,
            null,
            this.currentState.userListSettings.filter.groupType,
            this.currentState.userListSettings.filter.allSelected,
        )
    }

    _departmentsChanged(departmentController) {
        this.pagerController.loadPage(1); // need to reload user list because assignments can be changed

        const noGroupObj = departmentController.storedData.shift();
        const previouslySelectedGroupIds = this._rebuildGroupMapAndUpdateFilter(
            departmentController.storedData,
            this.timeZoneGroupList,
        );

        let deletedGroupFind = false;
        for (let groupId in previouslySelectedGroupIds.userGroups) {
            if (!this.userGroupMap[groupId]) {
                this._onGroupDeletedCallBack(); // reload page data if group deleted
                deletedGroupFind = true;
                break;
            }
        }

        departmentController.storedData.unshift(noGroupObj);
        const userIdGroupIdMap = this.convertToUserToGroupMap(departmentController.storedData);
        this.actions.updateDepartments(transformListToGroups(departmentController.storedData))
        this.actions.updateUsersGroups(userIdGroupIdMap)
        this.userTableController.updateUserGroups(userIdGroupIdMap, this.userGroupMap);
    }

    _timeZoneGroupsChanged(timeZoneGroupController) {
        const previouslySelectedTimeZoneGroupIds = this._rebuildGroupMapAndUpdateFilter(
            this.userGroupList,
            timeZoneGroupController.storedData
        )

        let deletedGroupFind = false;
        for (let groupId in previouslySelectedTimeZoneGroupIds.timeZoneGroups) {
            if (!this.timeZoneGroupMap[groupId]) {
                this._onGroupDeletedCallBack(); // reload page data if group deleted
                deletedGroupFind = true;
                break;
            }
        }

        const userIdGroupIdMap = this.convertToUserToGroupMap(timeZoneGroupController.storedData);
        this.userTableController.updateTimeZoneGroups(userIdGroupIdMap, this.timeZoneGroupMap);
        this.actions.updateUsersTimeZoneGroups(userIdGroupIdMap)
        this.actions. updateTimeZoneGroups(timeZoneGroupController.storedData)
    }

    _rebuildGroupMapAndUpdateFilter(userGroupList, timeZoneGroupList) {
        this.userGroupMap = this._initGroupMap(userGroupList, true)
        this.timeZoneGroupMap = this._initGroupMap(timeZoneGroupList, false)

        const previouslySelectedGroupIds = {userGroups: null, timeZoneGroups: null};

        const ids = this.currentState.userListSettings.filter.groupIds
        if (this._isUGREnabled()) {
            this.userGroupList = userGroupList
            previouslySelectedGroupIds.userGroups = ids !== null ? arrayToSet(ids) : {}
        }
        if (this._isTZGEnabled()) {
            this.timeZoneGroupList = timeZoneGroupList
            previouslySelectedGroupIds.timeZoneGroups = ids !== null ? arrayToSet(ids) : {}
        }

        this.usersFilter.setState({
            userGroups: userGroupList !== null ? transformListToGroups(addDefaultUserGroup(userGroupList)) : null,
            timeZoneGroups: transformListToGroups(this.timeZoneGroupList),
            groupType: this.currentState.userListSettings.filter.groupType,
            userIds: this.currentState.userListSettings.filter.userIds || [],
            groupIds: ids || [],
            allSelected: this.currentState.userListSettings.filter.allSelected,
        })
        return previouslySelectedGroupIds
    }

    _updateGroupsOnUserCreateOrUpdate(groupList, timeZoneGroupsList) {
        if (this._isUGREnabled() || this._isTZGEnabled())
            this._rebuildGroupMapAndUpdateFilter(groupList, timeZoneGroupsList);

        if (this._isUGREnabled()) {
            const userIdGroupIdMap = this.userTableController.makeUserIdGroupIdMapForVisibleUser();
            this.userTableController.updateUserGroups(userIdGroupIdMap, this.userGroupMap);
        }
        if (this._isTZGEnabled()) {
            const timeZoneIdGroupIdMap = this.userTableController.makeTimeZoneIdGroupIdMapForVisibleUser();
            this.userTableController.updateTimeZoneGroups(timeZoneIdGroupIdMap, this.timeZoneGroupMap);
        }
    }

    convertToUserToGroupMap(groupWithUsersList) {
        const userGroupMap = {};

        for (let i = 0; i < groupWithUsersList.length; i++) {
            const group = groupWithUsersList[i];
            const users = group.users;

            if (users)
                for (let j = 0; j < users.length; j++) {
                    const userId = group.users[j].id;
                    userGroupMap[userId] = group.id;
                }
        }

        return userGroupMap;
    }

    start() {
        this.showDisabledUsersChBox = new CustomCheckbox({
            label: messageResource.getMessage('userlist.show_disabled_users'),
            onChange: ({checked}) => {
                this.onShowDisabledUsersCallBack(checked)
            },
            checkboxTitleAdditionalClass: 'title',
        }).init($(document.getElementsByClassName("disabledAccountsCheckboxContainer")))
        this.showDisabledUsersChBox.setState({
            checked: this.currentState.userListSettings.filter.showDisabled
        })

        this.pagerController.render();
        this.initHeaderSelectorsFunction();
    }

    cl(func) {
        return () => { func.apply(this, arguments); }
    }

    createUser() {
        this.actions.openCreateUserPanel()
    }

    importUsersFinished(importedUsersData) {
        const userIds = importedUsersData.map(data => data.userId)
        const warningsPerUserId = new Map()
        for (let {userId, licenseViolated} of importedUsersData) {
            if (licenseViolated) {
                warningsPerUserId.set(userId, [UserManagementConstants.WARNING_ACCOUNT_DISABLED_DUE_TO_LICENSE_TERMS])
            }
        }
        if (userIds.length === 0) return;
        makeRpcCall(
            "UserManagementService.getCreatedUsers",
            [userIds],
            (usersData) => {
                // add warnings
                for (const user of usersData.additionalUsersInfo) {
                    if (warningsPerUserId.has(user.id)) {
                        user.warnings = warningsPerUserId.get(user.id)
                    }
                }

                const $body = $("body");
                const scrollTop = $body.scrollTop();
                this.createCallSucceeded(usersData, null, true, null, usersData.additionalUsersInfo, null);
                $body.scrollTop(scrollTop);
                this.actions.setStateOnInviteSeveralUsersSuccess(usersData)

            })
    }

    inviteSeveralUsers() {
        this._abortRequestsAndRevertState()

        this._showInviteUsersPopupLoadingMoire()
        makeRpcCall(
            "UserManagementService.getInviteSeveralUsersData",
            [],
            (inviteUsersData) => {
                this.showInviteSeveralUsersPopup(inviteUsersData)
            },
            (jqXHR, textStatus, errorThrown) => {
                this._hideInviteUsersPopupLoadingMoire()

                if (errorThrown.exception === 'com.actimind.actitime.services.NoRightsToManageAccountSettings') {
                    alert(messageResource.getMessage('userlist.js.error_cant_create_user_account'))
                    document.location.reload()
                    return true
                }
                if (errorThrown.msg.indexOf('com.actimind.common.licensing.NoActiveLicensesException') !== -1) {
                    alert(messageResource.getMessage('common.license_expired_exception.reload_page'))
                    document.location.reload();
                    return true
                }
                return false
            }
        )
    }

    showInviteSeveralUsersPopup(inviteUsersData) {
        this._hideInviteUsersPopupLoadingMoire();

        const lb = new ATInviteSeveralUsersLightBox().init({
            inviteUsersData,
            onChangePermissionsTemplates: ({templates}) => {this.actions.updateUserManagementData({permissionsTemplates: templates})},
            onHideCallback: () => {
                // show getting started menu if need
                if (!_.isUndefined(window.GettingStartedShortcuts)) {
                    window.GettingStartedShortcuts.showJustCheckedShortcutIfExists()
                }
            },
        })

        this.inviteSeveralUsersPopup = lb
        const changes = this._updateCurrentStateFromUserData(inviteUsersData);
        const pageUIMustBeUpdated = changes.featureDiff.areFeaturesChanged() || changes.areRightsChanged;

        lb.setSuccessCallback((userFieldsArray) => {
                if (userFieldsArray.length === 0) {
                    return
                }
                lb.disableUserInputWhileSaving();
                makeRpcCall("UserManagementService.inviteUsers", [userFieldsArray],
                    (inviteUsersResult) => {
                        lb.enableUserInputWhileSaving();
                        this.createSeveralUsersCallSucceeded(inviteUsersResult, lb, pageUIMustBeUpdated, changes.featureDiff)
                        this.actions.setStateOnInviteSeveralUsersSuccess(inviteUsersResult)
                    },
                    (jqXHR, textStatus, errorThrown) => {
                        lb.enableUserInputWhileSaving();
                        if (errorThrown.exception === "com.actimind.actitime.services.InviteSeveralUsersExceptionWithPermissionsTemplates") {
                            lb.showServerErrors(errorThrown.userTableErrors);
                            lb.updatePermissionsTemplatesData(errorThrown.permissionsTemplates);
                            return true;
                        }
                        if (errorThrown.exception === "com.actimind.actitime.administration.UserExistsException") {
                            alert(messageResource.getMessage("userlist.js.invite_user_mode_popup.duplicate_username"));
                            return true;
                        }
                        return false;
                    }
                );
            }
        );
        lb.setCancelCallback(() => {
            lb.hide();

            if (!this.validateIsChangedFeaturesOrRights(changes)) {
                if (pageUIMustBeUpdated)
                    this._updateUIAccordingToViewerPermissions();
                return;
            }

            this._updateGroupsOnUserCreateOrUpdate(inviteUsersData.userManagementData.allUserGroups,
                inviteUsersData.userManagementData.allTimeZoneGroups);
        });
        lb.show()
    }

    createSingleUserCallSucceeded(createUserResult, createLightBox, pageUIMustBeUpdated, oldFeatureDiff, userId) {
        this.createCallSucceeded(createUserResult, createLightBox, pageUIMustBeUpdated, oldFeatureDiff, [createUserResult.userInfo], userId);
    }

    createSeveralUsersCallSucceeded(inviteUsersResult, inviteLightBox, pageUIMustBeUpdated, oldFeatureDiff) {
        const $body = $("body");
        const scrollTop = $body.scrollTop();
        const userId = inviteUsersResult.additionalUsersInfo ? inviteUsersResult.additionalUsersInfo[0].id : null;
        this.createCallSucceeded(inviteUsersResult, inviteLightBox, pageUIMustBeUpdated, oldFeatureDiff, inviteUsersResult.additionalUsersInfo, userId);
        $body.scrollTop(scrollTop);
        inviteLightBox.switchToUsersInvitedState(inviteUsersResult.additionalUsersInfo);
    }

    createCallSucceeded(createResult, createLightBox, pageUIMustBeUpdated, oldFeatureDiff, userInfos, userId) {
        // mark on client that user(s) will be created
        if (!_.isUndefined(window.GettingStartedShortcuts) && userInfos.length > 0) {
            window.GettingStartedShortcuts.markShortcutAsChecked(window.GettingStartedShortcut.USERS);
        }

        const changeData = this._getDiffBetweenFeaturesAndRights(createResult, oldFeatureDiff);
        this.currentState.viewerSettings = createResult.viewerSettings;
        const featureDiff = changeData.featureDiff;

        if (!this.wasOperationSuccessful(createResult)) {
            this.handleError(createResult, createLightBox, userId);
        }
        else {

            pageUIMustBeUpdated |= featureDiff.areFeaturesChanged();

            let licenseChanged = false;

            if (this._hasManageAccountSettings()) {
                licenseChanged = this._isLicenseChanged(this.currentState.license, createResult.licenseCounters);
                this.currentState.license = createResult.licenseCounters;
            }

            this.validateIsChangedFeaturesOrRights(changeData);

            let groupName;

            this.actions.addNewUsersToList(userInfos)
            this._updateGroupsOnUserCreateOrUpdate(createResult.userGroups, createResult.timeZoneGroups);
            groupName = this._isUGREnabled() ? this.userGroupMap[userInfos[0].userGroupId] : " ";
            const timeZoneGroupName = this._isTZGEnabled() ? this.timeZoneGroupMap[userInfos[0].timeZoneGroupId] : " ";
            let warningMsgs;
            for (let i = userInfos.length - 1; i > -1; i--) {
                const userInfo = userInfos[i];
                warningMsgs = createWarningMsgs(userInfo, true);
                this.userTableController.addCreatedUser(userInfos[i], groupName, timeZoneGroupName, warningMsgs);
            }

            this.hideNoUsersCaptionAndBottomSpacer();

            if (createResult.additionalResultData !== null) {
                const additionalData = createResult.additionalResultData.map
                if (additionalData[AdditionalDataConstants.USERS_WITHOUT_APPROVERS_DATA]) {
                    this.userTableController.updateUsersWithoutApprovers(additionalData[AdditionalDataConstants.USERS_WITHOUT_APPROVERS_DATA])
                }
            }

            if (pageUIMustBeUpdated || licenseChanged)
                this._updateUIAccordingToViewerPermissions();

            this.currentState.noUsersShown = false;
        }
    }

    /**
     * @param userResult
     * @param dialog {UserDataLightBox|LeaveBalanceEditor}
     * @param userId
     */
    handleError(userResult, dialog, userId) {
        const errorMessage = ErrorMap[userResult.resultCode];

        if (!errorMessage && userResult.resultCode === UserManagementConstants.ERROR_BALANCE_CAP_EXCEEDED) {
            dialog.showCapExceededError(userResult.additionalResultData.map.cap);
            return false;
        }

        if (!errorMessage)
            throw "unknown user create/update/delete result error code:" + userResult.resultCode;

        if (userResult.resultCode === UserManagementConstants.ERROR_NO_RIGHTS_TO_MANAGE_ACCOUNT_SETTINGS ||
            userResult.resultCode === UserManagementConstants.ERROR_NO_RIGHTS_TO_MANAGE_PTO_AND_SICK ||
            userResult.resultCode === UserManagementConstants.ERROR_PTO_FEATURE_DISABLED ||
            userResult.resultCode === UserManagementConstants.ERROR_PTO_CONTROL_DISABLED ||
            userResult.resultCode === UserManagementConstants.ERROR_SICK_CONTROL_DISABLED) {
            dialog.hide();
            alert(messageResource.getMessage(errorMessage));
            this._reloadPage();
            return true;
        }

        if (userResult.resultCode === UserManagementConstants.ERROR_DUPLICATE_USERNAME) {
            dialog.handleSectionError(userResult.resultCode);
            return true;
        }

        if (userResult.resultCode === UserManagementConstants.ERROR_NO_SUCH_USER) {
            dialog.hide();
            alert(messageResource.getMessage(errorMessage));
            this._deleteUser(userId);
            return false;
        }

        alert(messageResource.getMessage(errorMessage));
    }

    /**
     * @param updateUserResult
     * @param dialog {UserDataLightBox|LeaveBalanceEditor}
     * @param pageUIMustBeUpdated
     * @param oldFeatureDiff
     * @param userId
     * @param previousTimeZoneGroupId
     * @param customErrHandler
     * @param forceNoHighlight
     */
    updateCallSucceeded(updateUserResult, dialog, pageUIMustBeUpdated, oldFeatureDiff,
        userId, previousTimeZoneGroupId = null, customErrHandler, forceNoHighlight) {
        const changeData = this._getDiffBetweenFeaturesAndRights(updateUserResult, oldFeatureDiff);
        const featureDiff = changeData.featureDiff;
        const viewerSettings = updateUserResult.viewerSettings
        this.currentState.viewerSettings = viewerSettings;

        if (updateUserResult.userInfo && (updateUserResult.userInfo.id === this.loggedInUserId)) {
            const isLeaveSettingsTabVisible = this.currentState.viewerSettings.allowedToManageLeaveBalanceSettings && (this._isPTOEnabled() || this._isSickEnabled());
            if (isLeaveSettingsTabVisible !== updateUserResult.userInfo.hasManagePTOAndSickRight) {
                this.currentState.viewerSettings.allowedToManageLeaveBalanceSettings = updateUserResult.userInfo.hasManagePTOAndSickRight;
                changeData.areAllowedToManageLeaveBalanceSettingsChanged = true;
            }
        }

        let successfulResult = this.wasOperationSuccessful(updateUserResult);

        if (!successfulResult) {
            if (dialog && !this.handleError(updateUserResult, dialog, userId))
                return this.validateIsChangedFeaturesOrRights(changeData);
            else if (customErrHandler)
                customErrHandler(updateUserResult);
        }
        else {
            pageUIMustBeUpdated |= featureDiff.areFeaturesChanged();

            let licenseChanged = false;

            if (this._hasManageAccountSettings()) {
                licenseChanged = this._isLicenseChanged(this.currentState.license, updateUserResult.licenseCounters);
                this.currentState.license = updateUserResult.licenseCounters;
            }

            if (dialog)
                dialog.hide();

            this.validateIsChangedFeaturesOrRights(changeData)

            if (previousTimeZoneGroupId !== null && this.loggedInUserId === updateUserResult.userInfo.id
                && previousTimeZoneGroupId !== updateUserResult.userInfo.timeZoneGroupId) {
                // update user list if user has changed his time zone
                alert(messageResource.getMessage('userlist.js.time_zone_was_changed'));
                this._reloadPage();
                return;
            }


            this._updateGroupsOnUserCreateOrUpdate(updateUserResult.userGroups, updateUserResult.timeZoneGroups);
            const userInfo = updateUserResult.userInfo;
            this.updateUser(userInfo, viewerSettings, !forceNoHighlight);
            if (updateUserResult.additionalUsersInfo) {
                const additionalUsersInfos = updateUserResult.additionalUsersInfo;
                for (let i = 0; i < additionalUsersInfos.length; i++)
                    this.updateUser(additionalUsersInfos[i], viewerSettings, false);
            }

            this._updateAdditionalData(updateUserResult)

            if (pageUIMustBeUpdated || licenseChanged)
                this._updateUIAccordingToViewerPermissions();

        }
    }

    updateUser(userInfo, viewerSettings, isHighlight) {
        const groupName = this._isUGREnabled() ? this.userGroupMap[userInfo.userGroupId] : "";
        const timeZoneGroupName = this._isTZGEnabled() ? this.timeZoneGroupMap[userInfo.timeZoneGroupId] : "";

        const warningMsgs = createWarningMsgs(userInfo, false);

        const editedUserIsLoggedInUser = userInfo.id === this.loggedInUserId;
        this.userTableController.updateUser(userInfo, viewerSettings, groupName, timeZoneGroupName, warningMsgs, editedUserIsLoggedInUser, !isHighlight);
    }

    _reloadPage() {
        location.reload()
    }

    wasOperationSuccessful(userResult) {
        return userResult.resultCode === UserManagementConstants.RESULT_CODE_SUCCESS;
    }

    updateOrDeleteCallSucceeded(confirmationNotNeededCallback) {
        if (confirmationNotNeededCallback)
            confirmationNotNeededCallback();
    }

    updateOrDeleteCallFailed(errorThrown, lightBox, resendRequestWithForceParameterCallback, hideLightBoxBeforeConfirmation) {
        let confirmationMessage;
        if (errorThrown.exception === "com.actimind.common.administration.EditUserConfirmationIsNeededException")
            confirmationMessage = new UserListConfirmation().createEditConfirmationMsg(errorThrown);
        else if (errorThrown.exception === "com.actimind.common.administration.DeleteUserConfirmationIsNeededException")
            confirmationMessage = new UserListConfirmation().createDeleteConfirmationMsg(errorThrown);
        else
            return false;


        if (hideLightBoxBeforeConfirmation)
            lightBox.hide();

        if (confirm(confirmationMessage))
            resendRequestWithForceParameterCallback();
        else if (!hideLightBoxBeforeConfirmation)
            lightBox.enableUserInputWhileSaving()

        return true
    }

    deleteCallSucceeded(deleteUserResult, userId, editLightBox, pageUIMustBeUpdated, oldFeaturesDiff) {

        const changeData = this._getDiffBetweenFeaturesAndRights(deleteUserResult, oldFeaturesDiff);
        this.currentState.viewerSettings = deleteUserResult.viewerSettings;


        if (deleteUserResult.userGroups !== null || deleteUserResult.timeZoneGroups !== null) {
            this._updateGroupsOnUserCreateOrUpdate(deleteUserResult.userGroups, deleteUserResult.timeZoneGroups);
        }
        const licenses = deleteUserResult.licenseCounters;
        if (licenses !== null && (pageUIMustBeUpdated || this._isLicenseChanged(this.currentState.license, licenses))) {
            this.currentState.license = licenses;
            this._updateUIAccordingToViewerPermissions();
        }

        this._updateAdditionalData(deleteUserResult)

        const result = deleteUserResult.resultCode;
        if (result === UserManagementConstants.RESULT_CODE_SUCCESS || result === UserManagementConstants.ERROR_NO_SUCH_USER) {
            this._deleteUser(userId);
            this.actions.removeUserFromList(userId)
        } else {
            alert(messageResource.getMessage(ErrorMap[result]));
        }
        this.validateIsChangedFeaturesOrRights(changeData);
    }

    _deleteUser(userId) {
        this.userTableController.deleteUser(userId);
        if (this.userTableController.getRows().length === 0) {
            this.pagerController.reloadEmptyPage();
        }
    }

    _deleteUsers(userIdsArray) {
        for (var i = 0, usersLength = userIdsArray.length; i < usersLength; i++)
            try {
                this.userTableController.deleteUser(userIdsArray[i]);
            }
            catch (e) {}// user with this id is not on this page, move on

        if (this.userTableController.getRows().length === 0) {
            this.pagerController.reloadEmptyPage();
        }
    }

    _initFilters() {
        this.managementFilter = new ManagementFilter({
            onChange: (value) => {
                this._filterChange('managementFilter', value)
            }
        }).init($('.userlist_managementFilter'))
        this.managementFilter.setState({
            selectedValue: this.currentState.userListSettings.filter.managementFilter,
        })
    }

    _updateAdditionalData(data) {
        if (data.additionalResultData !== null) {
            const additionalData = data.additionalResultData.map
            if (additionalData[AdditionalDataConstants.USERS_WITHOUT_APPROVERS_DATA]) {
                this.userTableController.updateUsersWithoutApprovers(additionalData[AdditionalDataConstants.USERS_WITHOUT_APPROVERS_DATA])
            }

            if (additionalData[AdditionalDataConstants.ALL_USERS_AUTOAPPROVED]) {
                this.userTableController.setUsersAutoapproved()
            }
        }
    }

    editUser(cell, tab) {
        this._abortRequestsAndRevertState();
        const userId = cell.getValue().id;
        this.actions.openEditUserPanel(userId, tab);
    }

    editTeamAssignments(cell) {
        this._abortRequestsAndRevertState();
        const userId = cell.getValue().id;
        this.actions.openTeamAssignmentsPanel(userId);
    }

    editManagementAssignments(cell) {
        this._abortRequestsAndRevertState()
        const userId = cell.getValue().id
        this.actions.openManagementAssignmentsPanel(userId, HierarchyLevels.CUSTOMER)
    }

    _showInviteUsersPopupLoadingMoire() {
        this._inviteUsersLoadingMoire = new LoadingPopup().init("inviteUsersLoadingPopup");
        this._inviteUsersLoadingMoire.show();
    }

    _hideInviteUsersPopupLoadingMoire() {
        this._inviteUsersLoadingMoire.hide();
    }

    switchManagePTOAndSickRight(cell) {
        this._abortRequestsAndRevertState();

        const cellValue = cell.getValue();
        const userId = cellValue.id;

        this.spinner.spin(this.spinnerEl);

        makeRpcCall('UserManagementService.setManagePTOAndSickRight',
            [userId, !cellValue.hasManagePTOAndSickRight],
            (result) => {
                this.spinner.stop();
                this.updateCallSucceeded(result, null, false, null, userId, undefined, this.defaultErrorHandler);
            },
            (jqXHR, textStatus, errorThrown) => {
                this.spinner.stop();
                return this.handlePTOExceptions(errorThrown, userId, this);
            }
        )
    }

    editBalance(cell, balanceType) {
        this._abortRequestsAndRevertState();

        const cellValue = cell.getValue();
        const userId = cellValue.id;
        const userName = UserNameFormat.formatFML(cellValue.firstName, cellValue.lastName, cellValue.middleInitial);
        let currentBalance;
        let titleMessageKey;
        if (balanceType === BalanceType.PTO) {
            currentBalance = cellValue.currentPTOBalance.balance;
            titleMessageKey = 'common.pto_editor.title'
        }
        if (balanceType === BalanceType.SICK) {
            currentBalance = cellValue.currentSickDaysBalance.balance;
            titleMessageKey = 'common.sick_editor.title'
        }

        this.addRowSelection(cell);

        this.leaveBalanceEditor.show(cell.getCellEl(), currentBalance, userName, this.ptoHoursPerDay, balanceType, titleMessageKey);
        this.leaveBalanceEditor.setOnCloseCallback(() => { this.clearRowSelection(cell) });
        this.leaveBalanceEditor.setOnApplyCallback((correctionType, valueInDays, comment) => {
            makeRpcCall("UserManagementService.addBalanceCorrection",
                [userId, correctionType, valueInDays, balanceType, comment],
                (result) => {
                    this.leaveBalanceEditor.busyModeOff();
                    this.updateCallSucceeded(result, this.leaveBalanceEditor, false, null, userId);
                },
                () => {
                    this.leaveBalanceEditor.busyModeOff();
                }
            )
        })
    }

    handlePtoHistoryError(resultCode, userId) {
        if (resultCode === UserManagementConstants.ERROR_NO_RIGHTS_TO_MANAGE_PTO_AND_SICK) {
            alert(messageResource.getMessage(ErrorMap[resultCode]));
            this._reloadPage();
        }
        else if (resultCode === UserManagementConstants.ERROR_NO_SUCH_USER) {
            alert(messageResource.getEscapedMessage("userlist.js.error_no_such_user.short"));
            this._deleteUser(userId);
        }

    }

    showSickHistory(cell) {
        this._balanceHistoryPanel.updateTitle(
            messageResource.getMessage("common.balance_history.balance_history_panel.title", [messageResource.getMessage("common.balance_history.table.sick")]));

        const config = {};
        config.balanceHistoryService = 'UserManagementService.getUserSickBalanceHistory';
        config.prefix = BalanceHistory.BalanceTypes.SICK;
        config.balanceType = BalanceType.SICK;
        config.showBalanceInHours = window.SystemSettings.showSickInHours;
        this.showBalanceHistory(cell, config);
    }

    showPtoHistory(cell) {
        this._balanceHistoryPanel.updateTitle(
            messageResource.getMessage("common.balance_history.balance_history_panel.title", [messageResource.getMessage("common.balance_history.table.pto")]));

        const config = {};
        config.balanceHistoryService = 'UserManagementService.getUserPtoBalanceHistory';
        config.prefix = BalanceHistory.BalanceTypes.PTO;
        config.balanceType = BalanceType.PTO;
        config.showBalanceInHours = window.SystemSettings.showPTOInHours;
        this.showBalanceHistory(cell, config);
    }

    showBalanceHistory(cell, historyConfig) {
        this._abortRequestsAndRevertState();

        const cellValue = cell.getValue();
        const userId = cellValue.id;

        const cellEl = cell.getCellEl();
        const jQcell = $(cellEl);
        const row = $(cell.getRow().getRowEl());
        this.addRowSelection(cell);
        this.showLoadingHistoryProgress(jQcell);

        makeRpcCall(
            historyConfig.balanceHistoryService,
            [userId],
            (extendedUserPtoBalanceHistoryData) => {
                jQcell.removeClass("hovered");
                if (!this.wasOperationSuccessful(extendedUserPtoBalanceHistoryData)) {
                    this.handlePtoHistoryError(extendedUserPtoBalanceHistoryData.resultCode, userId);
                    this.clearRowSelection(cell);
                    this.hideLoadingHistoryProgress(jQcell);
                }
                else {
                    new PanelBalanceHistoryTable(this.$tableContainerEl, extendedUserPtoBalanceHistoryData.userBalanceHistoryRecords.list, this.ptoHoursPerDay,
                        historyConfig.showBalanceInHours, historyConfig.prefix).init();
                    this._balanceHistoryPanel.setOnCloseCallback(() => {
                        row.removeClass("balanceHistorySelected");
                        this.clearRowSelection(cell)
                    });
                    this._balanceHistoryPanel.updateLinkState(extendedUserPtoBalanceHistoryData.userBalanceHistoryRecords.list.length, userId,
                        historyConfig.balanceType);
                    this._balanceHistoryPanel.showAt(cellEl, {my: "left top", at: "left bottom"});
                    this.hideLoadingHistoryProgress(jQcell);
                    row.addClass("balanceHistorySelected");
                }
            },
            () => {
                this.clearRowSelection(cell);
                this.hideLoadingHistoryProgress(jQcell);
                jQcell.removeClass("hovered");
            }
        )
    }

    defaultErrorHandler(userResult) {
        const errorMessage = messageResource.getMessage(ErrorMap[userResult.resultCode]);
        alert(errorMessage);
        location.reload();
    }

    handlePTOExceptions(errorThrown, userId, tableManager) {
        if (errorThrown.exception === 'com.actimind.actitime.administration.NoSuchUserException') {
            alert(messageResource.getMessage('userlist.js.error_no_such_user.edit_user'));
            tableManager._deleteUser(userId);
            return true;
        }
        if (errorThrown.exception === 'com.actimind.common.administration.UserPTOControlTurnedOff') {
            alert(messageResource.getMessage('userlist.js.error_pto_control_disabled'));
            this._reloadPage();
            return true;
        }
        if (errorThrown.exception === 'com.actimind.common.administration.UserSickBalanceControlTurnedOff') {
            alert(messageResource.getMessage('userlist.js.error_sick_control_disabled'));
            this._reloadPage();
            return true;
        }
        return false
    }

    toggleBalanceControlStatus(cell, balanceType, value) {
        this._abortRequestsAndRevertState();

        const cellValue = cell.getValue();
        const userId = cellValue.id;

        this.spinner.spin(this.spinnerEl);

        makeRpcCall('UserManagementService.setBalanceControlStatus',
            [userId, balanceType, value],
            (result) => {
                this.spinner.stop();
                this.updateCallSucceeded(result, null, false, null, userId, undefined, this.defaultErrorHandler);
            },
            (jqXHR, textStatus, errorThrown) => {
                this.spinner.stop();
                return this.handlePTOExceptions(errorThrown, userId, this);
            }
        )
    }

    modifyBalanceAccrualRules(cell, balanceType, dialogValues, onCompleteCallback) {
        this._abortRequestsAndRevertState();

        const cellValue = cell.getValue();
        const userId = cellValue.id;

        makeRpcCall('UserManagementService.setBalanceRules',
            [userId, balanceType, dialogValues.useDefaults, dialogValues.accrualRule, dialogValues.resetRule, dialogValues.capRule],
            (result) => {
                onCompleteCallback();
                this.updateCallSucceeded(result, null, false, null, userId, undefined, this.defaultErrorHandler);
            },
            (jqXHR, textStatus, errorThrown) => {
                onCompleteCallback();
                return this.handlePTOExceptions(errorThrown, userId, this);
            }
        )

    }

    getShowTooltip(tooltip) {
        return (config, event) => tooltip.updateUIAndShow(config, calculateTooltipOffset(tooltip, event, BOTTOM_BAR_HEIGHT))
    }

    getMoveTooltip(tooltip) {
        return (event) => tooltip.move(calculateTooltipOffset(tooltip, event, BOTTOM_BAR_HEIGHT))
    }

    getHideTooltip(tooltip) {
        return () => tooltip.hide()
    }

    addRowSelection(cell) {
        this.userTableController.addRowSelectionByIdx(cell.getRow().rowIdx)
    }

    clearRowSelection(cell) {
        this.userTableController.clearRowSelectionByIdx(cell.getRow().rowIdx)
    }

    showLoadingHistoryProgress(cell) {
        this.userTableController.showLoadingHistoryProgress(cell, this.spinner)
    }

    hideLoadingHistoryProgress(cell) {
        this.userTableController.hideLoadingHistoryProgress(cell, this.spinner)
    }

    _initTabs() {
        new TabsContainer().init($('.userList_tabsPlaceholder'))
    }

    _toggleTableClassForTabs(activeTabValue) {
        const isShowPTO = activeTabValue === UserManagementConstants.PTO_SETTINGS_TAB_NUM
        const isShowSickDays = activeTabValue === UserManagementConstants.SICK_DAYS_SETTINGS_TAB_NUM
        const isShowAccountSettings = activeTabValue === UserManagementConstants.ACCOUNT_SETTINGS_TAB_NUM
        const isShowWorkAssignments = activeTabValue === UserManagementConstants.WORK_ASSIGNMENTS_TAB_NUM

        const mainTableContainer = $('.userList_mainTableContainer')
        if (isShowWorkAssignments) {
            mainTableContainer.hide()

            this.workAssignmentsTableContainer.show()
            this.$workAssignmentsTablePlaceholder.show()
        } else {
            mainTableContainer.show()

            this.$workAssignmentsTablePlaceholder.hide()
            this.workAssignmentsTableContainer.hide()
        }
        this.$userListTableContainer.toggleClass("showPTOSettings", isShowPTO)
        this.$userListTableContainer.toggleClass("showSickDaysSettings", isShowSickDays)
        this.$userListTableContainer.toggleClass("showAccSettings", (isShowAccountSettings))
    }

    validateIsChangedFeaturesOrRights(changeData) {
        return this.validateCanViewUserList(changeData) &&
               this.validateIsChangedFeatures(changeData.featureDiff) &&
               this.validateIsChangedRights(changeData)
    }

    validateCanViewUserList(diffBetweenData) {
        if (!this._isPTOSettingsVisible() && !this._isSickDaysSettingsVisible() && !this._isAccountSettingsVisible()) {
            alert(messageResource.getMessage("userlist.js.error_no_right_to_view_userlist"))
            this._reloadPage()
            return false
        }

        return true;
    }

    validateIsChangedRights(diffBetweenData) {
        if (diffBetweenData.areAllowedToManageLeaveBalanceSettingsChanged) {
            this._onShowPTOSettingsChanged()
            return false
        }
        if (diffBetweenData.showAccountSettingsChanged) {
            this._onShowAccountSettingsChanged()
            return false
        }
        if (diffBetweenData.areAllowedToManageAccountSettingsChanged) {
            this._onManageAccountSettingsChanged()
            return false
        }
        return true
    }

    validateIsChangedFeatures(featureDiff) {
        if (featureDiff.wasFeatureChanged(UserManagementConstants.UGRFeature)) {
            this._onUGRChanged()
            return false
        }
        if (featureDiff.wasFeatureChanged(UserManagementConstants.TZGFeature)) {
            this._onTZGChanged()
            return false
        }
        if (featureDiff.wasFeatureChanged(UserManagementConstants.TTAFeature)) {
            this._onTTAChanged()
            return false
        }
        if (featureDiff.wasFeatureChanged(UserManagementConstants.PTOFeature)) {
            this._onPTOChanged()
            return false
        }
        if (featureDiff.wasFeatureChanged(UserManagementConstants.SDBFeature)) {
            this._onSickChanged()
            return false
        }

        this.validateGenerateMoneyReportsRightChanged(featureDiff)

        if (featureDiff.wasFeatureChanged(UserManagementConstants.OVRFeature)) {
            this._onOVRChanged()
            return false
        }

        if (featureDiff.wasFeatureChanged(UserManagementConstants.LVTFeature)) {
            this._onLVTChanged()
            return false
        }
        return true
    }

    validateGenerateMoneyReportsRightChanged(featureDiff) {
        if (this._isGenerateMoneyReportsRightChanged(featureDiff))
            this._onGenerateMoneyReportsRightChanged()

        if (this._isURAEnabled() !== featureDiff.wasFeatureEnabledBefore(UserManagementConstants.URAFeature) ||
            this._isBTYEnabled() !== featureDiff.wasFeatureEnabledBefore(UserManagementConstants.BTYFeature))
            this.userTableController.updatePermissionsColumn(this._isURAEnabled(), this._isBTYEnabled())
    }

    _isGenerateMoneyReportsRightChanged(featureDiff) {
        const generateMoneyReportsEnabled = this._isURAEnabled() || this._isBTYEnabled()
        const prevGenerateMoneyReportsEnabled = featureDiff.wasFeatureEnabledBefore(UserManagementConstants.URAFeature) ||
                                                featureDiff.wasFeatureEnabledBefore(UserManagementConstants.BTYFeature)

        return generateMoneyReportsEnabled !== prevGenerateMoneyReportsEnabled
    }

    getCurrentTime(timeZoneGroupId, successCallback, errorCallback) {
        makeRpcCall("CurrentTimeInfoService.getCurrentTimeInfo", [timeZoneGroupId], successCallback, errorCallback)
    }
}

export default connect(
    (state) => ({
        activeTabNum: getActiveTabNum(state),
        allowedToManageAccountSettings: isAllowedToManageAccountSettings(state),
        editingUserId: getEditingUserId(state),
        isBTYEnabled: isBTYEnabled(state),
        isURAEnabled: isURAEnabled(state),
        isUGREnabled: isUGREnabled(state),
        isTZGEnabled: isTZGEnabled(state),
        isTTAEnabled: isTTAEnabled(state),
        availableUsers: getSortedUsersList(state),
        permissionsTemplates: getPermissionsTemplates(state),
        isWaTabLoading: isLoading(state),
    }),
    (dispatch) => ({
        openEditUserPanel: bindActionCreators(openEditUserPanel, dispatch),
        openCreateUserPanel: bindActionCreators(openCreateUserPanel, dispatch),
        closeCreateUserPanel: bindActionCreators(closeCreateUserPanel, dispatch),
        setStateOnPageDataReceivedAction: bindActionCreators(setStateOnPageDataReceivedAction, dispatch),
        setStateOnInviteSeveralUsersSuccess: bindActionCreators(setStateOnInviteSeveralUsersSuccess, dispatch),
        openTeamAssignmentsPanel: bindActionCreators(openTeamAssignmentsPanelFromUserList, dispatch),
        openManagementAssignmentsPanel: bindActionCreators(openManagementAssignmentPanel, dispatch),
        addNewUsersToList: bindActionCreators(addNewUsersToList, dispatch),
        removeUserFromList: bindActionCreators(removeUserFromList, dispatch),
        updateUsersGroups: bindActionCreators(updateUsersGroups, dispatch),
        updateUsersTimeZoneGroups: bindActionCreators(updateUsersTimeZoneGroups, dispatch),
        updateDepartments: bindActionCreators(updateDepartments, dispatch),
        updateTimeZoneGroups: bindActionCreators(updateTimeZoneGroups, dispatch),
        updateUserManagementData: bindActionCreators(setUserManagementData, dispatch),
    })
)(UserManagementMediator)



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/UserManagementMediator.js